import { ensureError } from '@iot-middleware/shared'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: () => import('../views/Overview.vue'),
      },
      {
        path: 'applications',
        name: 'Networks',
        component: () => import('../views/Applications.vue'),
      },
      {
        path: 'network-hosts',
        name: 'Network hosts',
        component: () => import('../views/NetworkHosts.vue'),
      },
      {
        path: 'network-hosts/:id',
        name: 'Network host details',
        component: () => import('../views/NetworkHost.vue'),
      },
      {
        path: 'device-types',
        name: 'Device Types',
        component: () => import('../views/DeviceTypes.vue'),
      },
      {
        path: 'device-types/:id',
        name: 'Device type details',
        component: () => import('../views/DeviceType.vue'),
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue'),
      },
      {
        path: 'applications/:id',
        name: 'Network details',
        component: () => import('../views/Application.vue'),
      },
      {
        path: 'applications/:id/devices/:deviceId',
        name: 'Device details',
        component: () => import('../views/Application.vue'),
      },
      {
        path: 'data-consumers',
        name: 'Data consumers',
        component: () => import('../views/DataConsumers.vue'),
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
      },
      {
        path: 'users/:id',
        name: 'User details',
        component: () => import('../views/User.vue'),
      },
      {
        path: 'api-keys',
        name: 'API keys',
        component: () => import('../views/ApiKeys.vue'),
      },
      {
        path: 'api-keys/:id',
        name: 'API key details',
        component: () => import('../views/ApiKey.vue'),
      },
      {
        path: 'firmware',
        name: 'Firmware',
        component: () => import('../views/Firmwares.vue'),
      },
      {
        path: 'firmware/:id',
        name: 'Firmware details',
        component: () => import('../views/Firmware.vue'),
      },
      {
        path: 'queues',
        name: 'Queues',
        component: () => import('../views/Queues.vue'),
      },
      {
        path: 'organisation',
        name: 'Organisation',
        component: () => import('../views/Organisation.vue'),
      },
      {
        path: 'devices',
        name: 'Devices',
        component: () => import('../views/Devices.vue'),
      },
      {
        path: 'offlineDataConsumers',
        name: 'Offline data consumers',
        component: () => import('../views/OfflineDataConsumers.vue'),
      },
      {
        path: 'ssh-keys',
        name: 'SSH keys',
        component: () => import('../views/SshKeys.vue'),
      },
      {
        path: 'ssh-keys/:id',
        name: 'SSH key details',
        component: () => import('../views/SshKey.vue'),
      },
      {
        path: '/dashboard/*',
        name: 'Not Found ',
        component: () => import('../components/ContentNotFound.vue'),
      },
      // {
      //   path: 'device/:id',
      //   name: 'Device',
      //   component: () => import('../views/Device.vue')
      // }
    ],
  },
  {
    path: '/password-reset',
    name: 'Password Reset',
    component: () => import('../views/PasswordReset.vue'),
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Not Found',
    component: () => import('../components/ContentNotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.onError((e: unknown) => {
  const error = ensureError(e)
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    console.warn('failed to fetch module, redirecting to /')
    window.location.href = '/'
  }
})

export default router
